export function normalizeAnalyticsId(value) {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}

export function shouldEnableAnalytics({ id, nodeEnv }) {
  const normalizedId = normalizeAnalyticsId(id);
  return normalizedId.length > 0 && nodeEnv === 'production';
}

export function createGoogleTagScriptSrc(measurementId) {
  const normalizedId = normalizeAnalyticsId(measurementId);
  return `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(normalizedId)}`;
}

export function createGoogleTagFunction(dataLayer) {
  if (!dataLayer || typeof dataLayer.push !== 'function') {
    throw new Error('dataLayer.push is required');
  }

  return function gtag() {
    dataLayer.push(arguments);
  };
}

export function createGooglePageViewPayload({ fullPath, href, title } = {}) {
  const normalizedPath = typeof fullPath === 'string' ? fullPath.trim() : '';
  const pagePath = normalizedPath.length > 0 ? normalizedPath : '/';
  const pageLocation = typeof href === 'string' ? href.trim() : '';
  const pageTitle = typeof title === 'string' ? title.trim() : '';
  const payload = { page_path: pagePath };

  if (pageLocation.length > 0) {
    payload.page_location = pageLocation;
  }

  if (pageTitle.length > 0) {
    payload.page_title = pageTitle;
  }

  return payload;
}

export function runIsolatedAnalyticsTask(task) {
  try {
    task();
    return true;
  } catch (error) {
    console.error('[analytics] task failed:', error);
    return false;
  }
}
